module.exports = __webpack_public_path__ + "img/cities-and-cars-shuttlers.a852c80d.png";